import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';

import PERMISSIONS from '../constants/permissions';
import { angRoutes } from '../constants/router';
import { CommonPermissions, UserPermissions } from '../models/permissions';
import { AccessService } from '../services/access/access.service';
import { PermissionsService } from '../services/permissions/permissions.service';
import { recordLinks } from '../utils/route-id/route-id';

export const roleGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const permissionsService = inject(PermissionsService);
  const accessService = inject(AccessService);
  const router = inject(Router);

  const group = route.data['permission'] as keyof UserPermissions | undefined;
  const action = route.data['action'] as keyof CommonPermissions | undefined;

  if (!group) {
    return true;
  }

  const allowed = action
    ? permissionsService.hasPermission(group, action)
    : permissionsService.hasAnyPermission(group);

  if (allowed) {
    return true;
  }

  // As in stargate-portal: whoever may not list organizations is shown their own.
  const organizationId = accessService.getCurrentUser()?.organizationId;
  if (group === PERMISSIONS.ORGANIZATION && action === PERMISSIONS.ACTIONS.List && organizationId) {
    return router.parseUrl(recordLinks.organization(organizationId));
  }

  return router.createUrlTree([angRoutes.unauthorized.route]);
};
